/* ============================================================
   E2 Language — Ebook Store behaviour
   Handles: test filter pills, FAQ accordions, product-page
   bundle tier selection, and AJAX add-to-cart (/cart/add.js).
   No dependencies. Safe to load on every ebook page (each block
   guards on the presence of its own hook).
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    // Minimal formatter; Shopify money is in cents. Adjust symbol per store.
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------- Landing: filter pills (client-side filter by test) ---------- */
  function initFilter() {
    var bar = document.querySelector('[data-eb-filter]');
    var grid = document.querySelector('[data-eb-grid]');
    if (!bar || !grid) return;

    var pills = Array.prototype.slice.call(bar.querySelectorAll('.eb-pill'));
    var countEl = document.querySelector('[data-eb-count]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.eb-card'));

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.setAttribute('aria-pressed', String(p === pill)); });
        var f = pill.getAttribute('data-filter');
        var n = 0;
        cards.forEach(function (card) {
          var isBundle = card.hasAttribute('data-eb-bundle');
          // bundles are hidden under "All ebooks"; a test filter shows its ebooks + its bundle
          var show = f === 'all' ? !isBundle : card.getAttribute('data-test') === f;
          card.hidden = !show;
          if (show && !isBundle) n++;
        });
        if (countEl) countEl.textContent = n + (n === 1 ? ' ebook' : ' ebooks');
      });
    });
  }

  /* ---------- FAQ / accordions ---------- */
  function initFaq() {
    document.querySelectorAll('[data-eb-faq] .faq-item').forEach(function (item) {
      var btn = item.querySelector('.faq-question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- 3. Product page: bundle tiers ---------- */
  function initBundle() {
    var form = document.querySelector('[data-eb-bundle-form]');
    if (!form) return;

    var tiers = Array.prototype.slice.call(form.querySelectorAll('.eb-tier'));
    var cta = form.querySelector('[data-eb-cta]');

    var singleVariant = form.getAttribute('data-single-variant');
    var packVariant = form.getAttribute('data-pack-variant');   // may be null
    var packItems = form.getAttribute('data-pack-items');       // comma-separated variant ids (fallback: the 4 books)

    function selectTier(tier) {
      tiers.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        var input = t.querySelector('input');
        if (input) input.checked = on;
      });
      var priceOut = form.querySelector('[data-eb-cta-price]');
      if (priceOut) priceOut.textContent = money(parseInt(tier.getAttribute('data-price'), 10));
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        // let the sibling-picker buttons handle their own clicks
        if (e.target.closest('[data-eb-picks] button')) return;
        selectTier(tier);
      });
    });

    // second-book picker
    form.querySelectorAll('[data-eb-picks] button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var group = btn.closest('[data-eb-picks]');
        group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        selectTier(btn.closest('.eb-tier'));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var selected = form.querySelector('.eb-tier.is-selected');
      if (!selected) return;
      var tier = selected.getAttribute('data-tier');
      var items = [];

      if (tier === 'single') {
        items.push({ id: singleVariant, quantity: 1 });
      } else if (tier === 'two') {
        var pick = selected.querySelector('[data-eb-picks] button[aria-pressed="true"]');
        items.push({ id: singleVariant, quantity: 1 });
        if (pick) items.push({ id: pick.getAttribute('data-variant'), quantity: 1 });
        // The "buy 2+ ebooks, save 10%" automatic discount applies in cart (README §3).
      } else if (tier === 'pack') {
        if (packVariant) {
          items.push({ id: packVariant, quantity: 1 });
        } else if (packItems) {
          // No pack product yet — add the 4 books individually so add-to-cart still works.
          packItems.split(',').forEach(function (id) { if (id) { items.push({ id: id, quantity: 1 }); } });
        }
      }

      // If every item in the selected tier is already in the cart, don't re-add —
      // surface the same "already added" feedback the quick-add buttons give.
      var allInCart = items.length > 0 && items.every(function (it) {
        return _cartVariants[String(it.id)];
      });
      if (allInCart) {
        showToast('Already in your cart ✓ <a href="/cart">View cart →</a>');
        return;
      }

      addToCart(items, cta);
    });
  }

  /* ---------- Toast (default-cart feedback) ---------- */
  var _toastEl, _toastTimer;
  function getToast() {
    if (_toastEl) return _toastEl;
    var scope = document.createElement('div');
    scope.className = 'eb-scope';
    _toastEl = document.createElement('div');
    _toastEl.className = 'eb-toast';
    _toastEl.setAttribute('role', 'status');
    _toastEl.setAttribute('aria-live', 'polite');
    _toastEl.setAttribute('data-eb-toast', '');
    scope.appendChild(_toastEl);
    document.body.appendChild(scope);
    return _toastEl;
  }
  function showToast(html, opts) {
    opts = opts || {};
    var el = getToast();
    el.innerHTML = html;
    el.classList.toggle('eb-toast--error', !!opts.error);
    // force reflow so re-showing an already-visible toast re-triggers the transition
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');
    window.clearTimeout(_toastTimer);
    _toastTimer = window.setTimeout(function () {
      el.classList.remove('is-visible');
    }, opts.error ? 5000 : 4000);
  }

  /* ---------- Cart contents (drives the 'already added' state) ---------- */
  var _cartVariants = {};   // variant id (string) -> true when it is in the cart
  function markInCartButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eb-add]'), function (btn) {
      if (!btn.hasAttribute('data-eb-label')) btn.setAttribute('data-eb-label', btn.innerHTML);
      var id = String(btn.getAttribute('data-variant') || '');
      var inCart = !!(id && _cartVariants[id]);
      if (inCart && !btn.classList.contains('is-in-cart')) {
        btn.classList.add('is-in-cart');
        btn.innerHTML = 'Added ✓';
      } else if (!inCart && btn.classList.contains('is-in-cart')) {
        btn.classList.remove('is-in-cart');
        btn.innerHTML = btn.getAttribute('data-eb-label');
      }
    });
  }
  /* ---------- Floating cart button (persistent link to the cart) ---------- */
  var _cartBtn, _cartBtnCount;
  function getCartButton() {
    if (_cartBtn) return _cartBtn;
    var scope = document.createElement('div');
    scope.className = 'eb-scope';
    _cartBtn = document.createElement('a');
    _cartBtn.className = 'eb-cartbtn';
    _cartBtn.href = '/cart';
    _cartBtn.setAttribute('aria-label', 'View cart');
    _cartBtn.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6.5 7h14l-1.4 8.5a2 2 0 0 1-2 1.7H9.9a2 2 0 0 1-2-1.7z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
      '<path d="M6.5 7 5.4 3.6A1 1 0 0 0 4.45 3H2.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
      '<circle cx="10.5" cy="20" r="1.3" fill="currentColor"/><circle cx="17.5" cy="20" r="1.3" fill="currentColor"/></svg>' +
      '<span class="eb-cartbtn__count" data-eb-cart-count>0</span>';
    _cartBtnCount = _cartBtn.querySelector('[data-eb-cart-count]');
    scope.appendChild(_cartBtn);
    document.body.appendChild(scope);
    return _cartBtn;
  }
  function updateCartButton(count) {
    var btn = getCartButton();
    if (count && count > 0) {
      if (_cartBtnCount) _cartBtnCount.textContent = count;
      btn.setAttribute('aria-label', 'View cart, ' + count + (count === 1 ? ' item' : ' items'));
      btn.classList.add('is-shown');
    } else {
      btn.classList.remove('is-shown');
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        _cartVariants = {};
        var count = 0;
        if (cart && cart.items) {
          cart.items.forEach(function (it) { _cartVariants[String(it.variant_id || it.id)] = true; });
          count = typeof cart.item_count === 'number' ? cart.item_count : cart.items.length;
        }
        markInCartButtons();
        updateCartButton(count);
        return cart;
      })
      .catch(function () { return null; });
  }

  // Native form POST to /cart/add — a normal browser navigation that ad blockers
  // do NOT stop, so add-to-cart still works when fetch/XHR is blocked. Adds the
  // first line item (single-item quick-add); the page then lands on /cart.
  function fallbackFormAdd(items) {
    var first = items && items[0];
    if (!first || !first.id) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var form = document.createElement('form');
    form.method = 'post';
    form.action = root + 'cart/add';
    var idIn = document.createElement('input');
    idIn.type = 'hidden'; idIn.name = 'id'; idIn.value = first.id;
    var qtyIn = document.createElement('input');
    qtyIn.type = 'hidden'; qtyIn.name = 'quantity'; qtyIn.value = first.quantity || 1;
    form.appendChild(idIn); form.appendChild(qtyIn);
    document.body.appendChild(form);
    form.submit();
  }

  // Stamp the cart with flow_type=ebook so the resulting order carries an ebook
  // marker (mirrors the single-ebook buy-now flow in ebook-product.liquid). This
  // survives to the order and is used to gate post-purchase UI — e.g. hiding the
  // LMS "Access Dashboard" link on the Thank-You page for ebook-only orders.
  // Fire-and-forget: it must never block or fail the add.
  function markEbookFlow() {
    try {
      var attrs = { flow_type: 'ebook' };

      // Carry the OpenAI Ads attribution value into the order. The `__oppref`
      // cookie is first-party to this domain, and neither Shopify's checkout nor
      // the Custom Pixel sandbox can read it — but a cart attribute survives into
      // the order as a note attribute, which the server-side Conversions API call
      // can read back. Same smuggling trick the LMS flows use for flow_type.
      var oppref = window.E2OpenAIAds && window.E2OpenAIAds.oppref();
      if (oppref) { attrs.oppref = oppref; }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    } catch (e) { /* no-op — marker is best-effort */ }
  }

  // OpenAI Ads `items_added`. Fires only once /cart/add.js has confirmed the add —
  // never on the button click, per the implementation brief. Wrapped whole so a
  // tracking failure can never turn a successful add into an error toast.
  function trackItemsAdded(added) {
    try {
      if (!window.E2OpenAIAds) return;
      // /cart/add.js returns { items: [...] } for a batch add, or the bare line
      // item when a single item was added.
      var lines = (added && added.items) || (added && added.id ? [added] : []);
      if (!lines.length) return;

      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var total = 0;
      var contents = lines.map(function (li) {
        var qty = li.quantity || 1;
        total += typeof li.line_price === 'number' ? li.line_price : (li.price || 0) * qty;
        return {
          id: String(li.sku || li.variant_id || li.id || ''),
          name: li.product_title || li.title || '',
          content_type: 'product',
          quantity: qty,
          amount: window.E2OpenAIAds.amount(li.price || 0),
          currency: currency
        };
      });

      window.E2OpenAIAds.measure('items_added', {
        type: 'contents',
        amount: window.E2OpenAIAds.amount(total),
        currency: currency,
        contents: contents
      });
    } catch (e) { /* tracking must never break add-to-cart */ }
  }

  // Shopify's visitor token. cio.ts sends the Web Pixel's event.clientId as
  // anonId; _shopify_y is the cookie that value derives from, so anonymous
  // profiles created here line up with the ones the checkout pixel creates.
  // VERIFY once in DevTools: this cookie vs event.clientId in the pixel sandbox.
  function shopifyClientId() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]*)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  // Customer.io ebook cart event — the trigger for the abandoned-cart campaign.
  // "Abandonment" is decided in Customer.io (trigger on this, wait, exit on
  // completed_payment_ebook), not here; this only reports current cart state.
  //
  // Sends the WHOLE cart rather than the item just added, because a recovery
  // email has to show everything the shopper left behind.
  //
  // Deliverability note: an anonymous cart has no email address, so Customer.io
  // can store the event but cannot send to it. Guest ebook carts are therefore
  // only recoverable through Shopify's own abandoned-checkout flow.
  function trackEbookCart(cart) {
    try {
      var cfg = window.E2EbookCio;
      if (!cfg || !cfg.proxyUrl) return;
      if (!cart || !cart.items || !cart.items.length) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var checkoutUrl = (window.E2Referral && typeof window.E2Referral.getCheckoutUrl === 'function')
        ? window.E2Referral.getCheckoutUrl('checkout')
        : root + 'checkout';

      // Major units here, matching cio.ts (parseFloat of Shopify's decimal
      // amounts) so both senders agree on what `value` means in a campaign.
      var data = {
        item_count: typeof cart.item_count === 'number' ? cart.item_count : cart.items.length,
        value: (cart.total_price || 0) / 100,
        currency: cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        cart_url: root + 'cart',
        checkout_url: checkoutUrl,
        items: cart.items.map(function (it) {
          return {
            title: it.product_title || it.title || '',
            sku: it.sku || '',
            variant_id: it.variant_id || it.id,
            quantity: it.quantity || 1,
            price: (it.price || 0) / 100,
            url: it.url ? (window.location.origin + it.url) : null,
            image: it.image || null
          };
        })
      };

      fetch(cfg.proxyUrl, {
        method: 'POST',
        // text/plain keeps this a CORS simple request — no preflight, same as
        // snippets/cio-package-tracking.liquid and cio.ts.
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          name: 'ebook_cart_updated',
          email: cfg.email || null,
          anonId: shopifyClientId(),
          data: data
        }),
        keepalive: true
      }).catch(function () {});
    } catch (e) { /* tracking must never break the cart */ }
  }

  function addToCart(items, cta) {
    if (!items.length) return;
    var original = cta ? cta.innerHTML : '';
    if (cta) { cta.setAttribute('disabled', 'disabled'); cta.textContent = 'Adding…'; }

    var request;
    try {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    } catch (e) {
      // fetch missing/blocked synchronously — go straight to the native form
      fallbackFormAdd(items);
      return;
    }

    request
      .then(function (r) {
        if (!r.ok) { var err = new Error('rejected'); err.serverError = true; throw err; }
        return r.json();
      })
      .then(function (added) {
        if (cta) { cta.removeAttribute('disabled'); cta.innerHTML = original; }
        trackItemsAdded(added);  // OpenAI Ads — confirmed add only
        markEbookFlow();  // stamp flow_type=ebook on the cart for post-purchase gating
        // refresh cart state (flips buttons to 'Added ✓') and get the count; never fails the add
        return refreshCart();
      })
      .then(function (cart) {
        trackEbookCart(cart);  // Customer.io — abandoned-cart campaign trigger
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        var suffix = count ? ' · ' + count + (count === 1 ? ' item' : ' items') + ' in cart' : '';
        showToast('Added to cart ✓' + suffix + ' <a href="/cart">View cart →</a>');
      })
      .catch(function (err) {
        if (cta) { cta.removeAttribute('disabled'); cta.innerHTML = original; }
        if (err && err.serverError) {
          // Shopify itself rejected the add (e.g. genuinely unavailable) — show the error
          showToast('Couldn\'t add to cart. Please try again.', { error: true });
        } else {
          // the fetch was blocked/failed (ad blocker, offline) — native form add always works
          fallbackFormAdd(items);
        }
      });
  }

  /* ---------- 4. Quick add-to-cart (grid cards, complete packs, cross-sell) ---------- */
  function initQuickAdd() {
    document.querySelectorAll('[data-eb-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant');
        if (!id) return;
        if (_cartVariants[String(id)]) {
          showToast('Already in your cart ✓ <a href="/cart">View cart →</a>');
          return;
        }
        addToCart([{ id: id, quantity: 1 }], btn);
      });
    });
    refreshCart();   // reflect items already in the cart on page load
  }

  /* ---------- init ---------- */
  function init() {
    initFilter();
    initFaq();
    initBundle();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
